import { isClient } from '@/utils/isClient';
import { logger } from '@/utils/logger';

export const showOneTrustConsent = () => {
  if (!isClient()) {
    return;
  }

  const hasDidomiScript = document.querySelector('script[src*="/cmp/didomi.js"]') !== null;

  if (window.Didomi) {
    window.Didomi.preferences.show('purposes');
    return;
  }

  if (hasDidomiScript) {
    window.didomiOnReady = window.didomiOnReady || [];
    window.didomiOnReady.push((Didomi) => {
      Didomi.preferences.show('purposes');
    });
    return;
  }

  if (window.OneTrust) {
    window.OneTrust.ToggleInfoDisplay();
  } else {
    logger.info('Neither Didomi nor OneTrust is available');
  }
};
